import React, {useMemo} from 'react';
import Skeleton from 'react-loading-skeleton'
const IframeResizer = React.lazy(()=>import('./LazyIframeResizer'))

export default function IFrameComponent({src}){
  const url = useMemo(()=>{
    if(src){
      try{
        const u = new URL(src)
        u.searchParams.append('access_token',localStorage.getItem('access_token'))
        return u.href;
      }catch(e){

      }
    }
  },[src])
  return <React.Suspense fallback={<Skeleton height={200} />}>
    <IframeResizer src={url}/>
  </React.Suspense>
}
